import React from 'react';
import { Nav, MenuButton } from 'components';
import Link from 'next/link';

const Header = ({ focused, ...props }) => {
    const [showNavigation, setShowNavigation] = React.useState();
    const toggleNavigation = () => setShowNavigation(!showNavigation);
    if(focused){
        return (
            <div style={{ display:'flex', justifyContent:'center' }}>
                <img src="/static/gfx/PenlyLogo.svg" style={{ height:40, marginTop:24 }} />
            </div>
        );

    }
    return (
        <header className={ showNavigation ? 'navvisible' : '' } { ...props }>
            <div>
                <Link href="/">
                    <a></a>
                </Link>
            </div>
            <Nav toggleNavigation={ toggleNavigation } />
            <MenuButton onClick={ toggleNavigation } />
        </header>
    );
};

export default Header;
